import React from 'react'
import styled from 'styled-components'

const PressureValue = ({ value, unit }: { value: number | string, unit: string }) => {
  const formattedValue = value !== '' ? parseFloat(String(value)).toFixed(2) : value
  return (
    <S.Container>
      <S.PressureGaugeIcon />

      <S.Value>{formattedValue} {unit}</S.Value>
    </S.Container>
  )
}

export default PressureValue

const S = {
  Container: styled.div`
    display: flex;
    margin-bottom: 15px;
  `,
  PressureGaugeIcon: styled.span`
    width: 22px;
    height: 22px;
    margin-right: 5px;
    background-image: url('/img/pressure_gauge.svg');
    background-size: contain;
    background-repeat: no-repeat;
  `,
  Value: styled.span`
  `
}
